import { useState, useEffect, useRef } from 'react';

function useVisibleAnimation(shouldAnimate) {
    const [isVisible, setIsVisible] = useState(false);
    const [isComponentReady, setIsComponentReady] = useState(false);
    const timerRef = useRef(null);

    const collapseTransition = {
        enter: {
            duration: 0.45,
            ease: 'easeOut',
        },
        exit: {
            duration: 0.4,
            ease: 'easeIn',
        },
    };

    useEffect(() => {
        // Mark component as ready after first render
        const readyTimer = setTimeout(() => {
            setIsComponentReady(true);
        }, 50); // Small delay to ensure component is fully mounted

        return () => clearTimeout(readyTimer);
    }, []);

    useEffect(() => {
        if (!isComponentReady) return;

        if (shouldAnimate) {
            // Wait 400ms, then start the animation
            timerRef.current = setTimeout(() => {
                setIsVisible(true);
            }, 400);
        } else {
            // No animation needed - show immediately
            setIsVisible(true);
        }

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [shouldAnimate, isComponentReady]);

    return { isComponentReady, isVisible, collapseTransition };
}

export { useVisibleAnimation };
